import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, LILAC_300, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { SearchComponent } from './components/SearchComponent';
import { getSearchHeaderStyles } from './SearchHeaderWidgetStyles';
export var SearchHeaderWidgetComponent = props => {
  var _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? LILAC_300 : _props$backgroundColo,
    height = props.height,
    _props$leftIcon = props.leftIcon,
    leftIcon = _props$leftIcon === void 0 ? 'LeftArrowIcon' : _props$leftIcon,
    _props$leftIconSize = props.leftIconSize,
    leftIconSize = _props$leftIconSize === void 0 ? 'sm' : _props$leftIconSize,
    _props$leftIconType = props.leftIconType,
    leftIconType = _props$leftIconType === void 0 ? 'secondary' : _props$leftIconType,
    _props$voiceEnabled = props.voiceEnabled,
    voiceEnabled = _props$voiceEnabled === void 0 ? false : _props$voiceEnabled,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    onUserAction = props.onUserAction,
    onLeftCtaPressMetaData = props.onLeftCtaPressMetaData,
    onSubmitActionMetaData = props.onSubmitActionMetaData,
    onChangeActionMetaData = props.onChangeActionMetaData,
    onClearActionMetaData = props.onClearActionMetaData,
    _props$minCharacters = props.minCharacters,
    minCharacters = _props$minCharacters === void 0 ? 3 : _props$minCharacters,
    accessibilityProps = props.accessibilityProps,
    value = props.value,
    _props$charLimit = props.charLimit,
    charLimit = _props$charLimit === void 0 ? 48 : _props$charLimit,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'SearchHeaderWidgetComponent' : _props$testID,
    _props$isTextSubmitte = props.isTextSubmitted,
    isTextSubmitted = _props$isTextSubmitte === void 0 ? false : _props$isTextSubmitte,
    _props$showLoader = props.showLoader,
    showLoader = _props$showLoader === void 0 ? false : _props$showLoader,
    _props$showClearButto = props.showClearButton,
    showClearButton = _props$showClearButto === void 0 ? true : _props$showClearButto,
    _props$state = props.state,
    state = _props$state === void 0 ? 'focused' : _props$state,
    _props$hintText = props.hintText,
    hintText = _props$hintText === void 0 ? '' : _props$hintText,
    appendItems = props.appendItems,
    parentAccessibilityProps = props.parentAccessibilityProps;
  var getExtraData = function getExtraData(text, isSubmitted) {
    if (isSubmitted === void 0) {
      isSubmitted = false;
    }
    var _a;
    return {
      text,
      minCharacters,
      isSubmitted,
      formattedValue: (_a = text === null || text === void 0 ? void 0 : text.split('')) === null || _a === void 0 ? void 0 : _a.join(' ')
    };
  };
  var onValidInput = event => {
    var text = event.nativeEvent.text;
    if (onSubmitActionMetaData) {
      onUserAction(onSubmitActionMetaData, getExtraData(text, true));
    }
  };
  var onChangeText = text => {
    if (onChangeActionMetaData) {
      onUserAction(onChangeActionMetaData, getExtraData(text, isTextSubmitted !== null && isTextSubmitted !== void 0 ? isTextSubmitted : false));
    }
  };
  var onClear = () => {
    if (onClearActionMetaData) onUserAction(onClearActionMetaData, props);
  };
  var onPress = () => {
    if (onLeftCtaPressMetaData) onUserAction(onLeftCtaPressMetaData, props);
  };
  var searchHeaderStyles = getSearchHeaderStyles(height, backgroundColor);
  return _jsxs(View, Object.assign({
    style: searchHeaderStyles.viewStyle
  }, getTestId(testID), {
    children: [_jsx(IconButton, Object.assign({
      style: searchHeaderStyles.leftCtaStyle,
      controlState: "hover",
      theme: "light",
      iconName: leftIcon,
      labelPosition: "right",
      size: leftIconSize,
      type: leftIconType,
      onPress: onPress
    }, accessibilityProps, getTestId(testID, 'leftCta'))), _jsx(View, Object.assign({
      style: searchHeaderStyles.searchContainerStyle
    }, parentAccessibilityProps, {
      children: _jsx(SearchComponent, Object.assign({
        onClear: onClear,
        onValidInput: onValidInput,
        onChangeText: onChangeText,
        voiceEnabled: voiceEnabled,
        placeholder: placeholder,
        accessibilityProps: accessibilityProps,
        value: value,
        maxLength: charLimit,
        showLoader: showLoader,
        showClearButton: showClearButton,
        state: state,
        hintText: hintText,
        appendItems: appendItems
      }, getTestId(testID, 'input')))
    }))]
  }));
};
SearchHeaderWidgetComponent.genericRendererKey = 'AirSearchHeaderWidget';